import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  acknowledgeSuccess,
  alternativeOfferConfirmationJobMock,
  alternativeOfferInProgressJobMock,
  cancelAndRefundOrderMockOutboundDisruptedRefundable,
  getAlternativeOffersMockDisruptedInbound,
  getOrderEligibilitiesMockDisruptedOutboundRefundable,
  retrieveOrderMockDisruptedOutbound,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
  servicesCancelledWarning,
  servicesNotRefundableWarning,
} from '../../../mock/dictionaries';

export const disruptedOutboundRefundableMock: MockMap = {
  retrieveOrder: [createMockData(retrieveOrderMockDisruptedOutbound, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(getOrderEligibilitiesMockDisruptedOutboundRefundable, [], [servicesNotRefundableWarning])],
  cancelAndRefundOrder: [createMockDataWithResponse(cancelAndRefundOrderMockOutboundDisruptedRefundable, 201, [], [servicesCancelledWarning])],
  getAlternativeOffers: [createMockData(getAlternativeOffersMockDisruptedInbound)],
  createAsynchronousJobForAlternativeOfferConfirmation: [createMockData(alternativeOfferInProgressJobMock)],
  getAlternativeOfferConfirmationJob: [createMockData(alternativeOfferConfirmationJobMock)],
  acknowledge: [createMockData(acknowledgeSuccess)]
};
